/**
 * Stable key for the email context shown in a task pane.
 * Read mode uses internetMessageId; compose prefers reply linkage, then draft EntryID.
 * @param {object | null | undefined} snapshot
 * @returns {string}
 */
export const getItemContextKey = (snapshot) => {
  if (!snapshot) {
    return "";
  }
  if (snapshot.isCompose) {
    return (
      snapshot.inReplyTo ||
      snapshot.internetMessageId ||
      snapshot.entryId ||
      ""
    );
  }
  // Prefer internetMessageId; fall back to itemId so switches still detect when
  // internetMessageId is missing (some mailbox types / timing on ItemChanged).
  return snapshot.internetMessageId || snapshot.entryId || "";
};
